import React from 'react';
import Contact from '../components/Contact';

const ContactPage: React.FC = () => {
  return (
    <div className="pt-16">
      <Contact />
    </div>
  );
};

export default ContactPage;
